/* 1. Font Import */
@import url('https://fonts.googleapis.com/css2?family=Onest:wght@100..900&display=swap');

/* 2. Container (acts as top-level wrapper: apply to your main Contacts element) */
.container {
  /* Base typography & background (formerly in global body) */
  font-family: 'Onest', sans-serif;
  font-size: 16px;
  color: #505050;
  /* background-color: #ffffff; */
  line-height: 1.5;
  margin: 0;
  padding: 0;

  /* Layout */
  width: 90%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

/* 3. Hero / Page Title */
.pageHero {
  background-color: #fffdf7;
  padding: 20px 0;
  text-align: center;
}

.title {
  font-size: 2rem;
  font-weight: 400;
  margin-bottom: 8px;
  color: #505050;
}

.subtitle {
  font-size: 1.2rem;
  color: #505050;
  margin-bottom: 32px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  font-weight: 200;
}

.pageHero h1 {
  font-size: 2rem;
  font-weight: 400;
  margin-bottom: 8px;
}

.pageHero p {
  font-size: 1rem;
  color: #505050;
}

/* 4. Contact Section */
.contactSection {
  padding: 20px 0;
}

.contactColumns {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  margin-top: 16px;
}

/* 4.1. Contact Form */
.contactFormWrapper {
  flex: 1 1 500px;
  padding: 32px;
  border-radius: 10px;
  corner-shape: superellipse(1.18);
}

.contactForm .formGroup {
  margin-bottom: 16px;
}

.contactForm label {
  display: block;
  font-weight: 300;
  margin-bottom: 8px;
  color: #505050;
}

.contactForm input,
.contactForm textarea {
  width: 100%;
  max-width: 100%;
  padding: 12px;
  border: 1px solid #cccccc;
  border-radius: 10px;
  corner-shape: superellipse(1.18);
  font-size: 1rem;
  font-family: 'Onest', sans-serif;
  color: #505050;
  box-sizing: border-box;
}

.contactForm input:focus,
.contactForm textarea:focus {
  outline: none;
  border-color: #c0392b;
}

.modalTitle {
  font-weight: 400;
}

.emailForm input,
.emailForm textarea {
  width: 80%;
  padding: 8px;
  border: 1px solid #cccccc;
  border-radius: 10px;
  corner-shape: superellipse(1.18);
  font-size: 1rem;
  font-family: 'Onest', sans-serif;
  color: #505050;
  box-sizing: border-box;
}

.emailForm input:focus,
.emailForm textarea:focus {
  outline: none;
  border-color: #c0392b;
}

.btnSubmit {
  background-color: #c0392b;
  color: #fffdf7;
  padding: 8px 16px;
  border: none;
  border-radius: 10px;
  corner-shape: superellipse(1.18);
  font-weight: 300;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btnSubmit:hover {
  background-color: #a8322a;
}

/* 4.2. Contact Info */
.contactDetailsContainer {
  display: flex;
  justify-content: space-between;
}

.contactInfo {
  flex: 1 1 350px;
  background-color: #fffdf7;
  padding: 20px;
  border-radius: 10px;
  corner-shape: superellipse(1.18);
}

.infoList {
  list-style-type: none;
  padding-left: 0;
}

.contactInfo h2 {
  font-size: 1.5rem;
  margin-bottom: 16px;
}

.buttonContainer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.infoList li {
  margin-bottom: 16px;
}

.infoLabel {
  display: block;
  font-weight: 300;
  color: #505050;
  margin-bottom: 8px;
}

.infoText {
  color: #505050;
  font-size: 0.95rem;
}

.infoText:hover {
  color: #505050;
  text-decoration: underline;
}

/* 5. Map Embed */
.mapWrapper {
  margin-top: 32px;
  border-radius: 10px;
  corner-shape: superellipse(1.18);
  overflow: hidden;
}

/* 6. Social Icons */
.socialContainer {
  text-align: end;
}

.socialIcons {
  margin-top: 10px;
}

.socialIcons img {
  width: 30px;
  height: 30px;
  margin: 0 5px;
  cursor: pointer;
}

.error {
  color: #d32f2f;
  font-size: 12px;
  margin-top: 4px;
}

/* 7. Responsive Tweaks */
@media (max-width: 768px) {
  .contactFormWrapper {
    flex: 1 1 100%;
  }
  .contactColumns {
    flex-direction: column;
  }
  .socialIcons img {
    width: 25px;
    height: 25px;
  }
  .socialContainer {
    text-align: end;
  }
}

@media (max-width: 480px) {
  .pageHero {
    padding: 10px 0;
  }
  .contactSection {
    padding: 10px 0;
  }
  .contactFormWrapper {
    padding: 10px;
    box-sizing: border-box;
    overflow: auto;
    max-width: 100%;
  }
  .contactDetailsContainer {
    display: block;
  }
  .socialContainer {
    text-align: start;
  }
}
